import { useEffect, useState } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

// Shown until /policy/summary answers, and if it never does. Matches backend/policy.py's default.
const FALLBACK = {
    product_name: "EstateOps",
    tagline: "Every pound traced to a deed clause and a source document",
};

// Account role -> the persona the platform policy brands for. Signed-out visitors get "default".
const PERSONA_BY_ROLE = {
    estate_admin: "director",
    resident: "resident",
    household_admin: "resident",
    agency_viewer: "agent",
};

// One request per page load; every component using the hook shares it.
let summaryPromise = null;

function loadSummary() {
    if (!summaryPromise) {
        summaryPromise = api
            .get("/policy/summary")
            .then((res) => res.data)
            .catch(() => {
                summaryPromise = null;
                return null;
            });
    }
    return summaryPromise;
}

/** The product name and tagline for the signed-in user's persona (operator policy, S1/S2). */
export function useBranding() {
    const { user } = useAuth();
    const persona = PERSONA_BY_ROLE[user?.role] || "default";
    const [summary, setSummary] = useState(null);

    useEffect(() => {
        let cancelled = false;
        loadSummary().then((data) => {
            if (!cancelled) setSummary(data);
        });
        return () => {
            cancelled = true;
        };
    }, []);

    return { ...FALLBACK, ...(summary?.branding?.[persona] || summary?.branding?.default || {}) };
}
